export default {
  en: {
    free: 'Free',
    given: 'Given away',
    sold: 'Sold',
  },
};
